import { FilterOption } from './types'

export const filterOptions: FilterOption[] = [
  {
    order: 10,
    key: 'initialCreatedDate',
    label: 'Fecha Creación Desde',
    type: 'date'
  },
  {
    order: 11,
    key: 'finalCreatedDate',
    label: 'Fecha Creación Hasta',
    type: 'date'
  },
  {
    order: 12,
    key: 'sku',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 13,
    key: 'action',
    label: 'Acción',
    type: 'text'
  },
  {
    order: 14,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 15,
    key: 'zoneId',
    label: 'Zona',
    type: 'precreated'
  },
  {
    order: 16,
    key: 'typeAlertId',
    label: 'Tipo de Alerta',
    type: 'precreated'
  },
  {
    order: 17,
    key: 'flowId',
    label: 'Origen de Alerta',
    type: 'precreated'
  },
  {
    order: 18,
    key: 'batchNumber',
    label: 'Lote',
    type: 'text'
  },
  {
    order: 19,
    key: 'initialExpirationDate',
    label: 'Fecha Expiración Desde',
    type: 'date'
  },
  {
    order: 20,
    key: 'finalExpirationDate',
    label: 'Fecha Expiración Hasta',
    type: 'date'
  },
  {
    order: 21,
    key: 'typePositionId',
    label: 'Tipo Posición',
    type: 'precreated'
  }
]

export const defaultFilters = []
